import actionTypes, {
  ATTENDANCE,
  ATTENDANCE_CSV,
  ATTENDANCE_GROUP,
  ATTENDANCE_QR_CODE,
  ATTENDANCE_TABLE,
  ATTENDANCE_TABLE_MODULE,
  ATTENDANCE_TABLE_STUDENT,
} from '../constants/actionTypes'

export const attendanceCreate = payload => ({
  type: actionTypes[ATTENDANCE].pending,
  payload,
})
export const attendanceGroup = payload => ({
  type: actionTypes[ATTENDANCE_GROUP].pending,
  payload,
})

export const attendanceGroupClear = () => ({
  type: actionTypes[ATTENDANCE_GROUP].clear,
})

export const attendanceTable = payload => ({
  type: actionTypes[ATTENDANCE_TABLE].pending,
  payload,
})

export const attendanceTableStudent = payload => ({
  type: actionTypes[ATTENDANCE_TABLE_STUDENT].pending,
  payload,
})

export const attendanceTableCsv = payload => ({
  type: actionTypes[ATTENDANCE_CSV].pending,
  payload,
})

export const attendanceTableStudentClear = () => ({
  type: actionTypes[ATTENDANCE_TABLE_STUDENT].clear,
})
export const attendanceTableClear = () => ({
  type: actionTypes[ATTENDANCE_TABLE].clear,
})

export const attendanceTableModule = payload => ({
  type: actionTypes[ATTENDANCE_TABLE_MODULE].pending,
  payload,
})

export const attendanceTableModuleClear = () => ({
  type: actionTypes[ATTENDANCE_TABLE_MODULE].clear,
})

export const attendanceQRCode = payload => ({
  type: actionTypes[ATTENDANCE_QR_CODE].pending,
  payload,
})

export const attendanceQRCodeClear = () => ({
  type: actionTypes[ATTENDANCE_QR_CODE].clear,
})
